/**
 * FAQ Show More Component
 * Handles showing/hiding FAQ items based on max_items_to_show setting
 */

function initFaqShowMore() {
  const buttons = document.querySelectorAll('[data-faq-show-more]');

  buttons.forEach((button) => {
    // Skip if already initialized
    if (button.dataset.initialized === 'true') return;

    const accordion = button.closest('[data-faq-accordion]');
    if (!accordion) return;

    const hiddenItems = Array.from(
      accordion.querySelectorAll('.faq-hidden-item')
    );

    if (hiddenItems.length === 0) {
      button.closest('.faq-show-more-wrapper')?.style.setProperty('display', 'none');
      return;
    }

    let isExpanded = false;

    button.addEventListener('click', (event) => {
      event.preventDefault();
      isExpanded = !isExpanded;

      // Toggle visibility of hidden items
      hiddenItems.forEach((item) => {
        if (isExpanded) {
          item.classList.add('faq-visible');
        } else {
          item.classList.remove('faq-visible');
        }
      });

      // Update button text and aria-expanded
      const showMoreText = button.querySelector('.faq-show-more-text');
      const showLessText = button.querySelector('.faq-show-less-text');

      if (showMoreText && showLessText) {
        if (isExpanded) {
          showMoreText.style.display = 'none';
          showLessText.style.display = 'inline';
          button.setAttribute('aria-expanded', 'true');
        } else {
          showMoreText.style.display = 'inline';
          showLessText.style.display = 'none';
          button.setAttribute('aria-expanded', 'false');
          
          // Scroll to first visible item after collapse
          setTimeout(() => {
            const firstVisibleItem = accordion.querySelector(
              '.faq-accordion-item:not(.faq-hidden-item)'
            );
            if (firstVisibleItem) {
              firstVisibleItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
          }, 300);
        }
      }
    });

    // Mark as initialized
    button.dataset.initialized = 'true';
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFaqShowMore);
} else {
  initFaqShowMore();
}

// Also handle dynamically loaded content (Shopify theme editor)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initFaqShowMore);
  document.addEventListener('shopify:section:reorder', initFaqShowMore);
}

